import { render } from "./EmployeeApproveLiquidation.vue?vue&type=template&id=347d32b2"
import script from "./EmployeeApproveLiquidation.vue?vue&type=script&lang=js"
export * from "./EmployeeApproveLiquidation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__